/**************************************************
 * Nombre:       Formulario_Lista_Productos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import {
    AccountCircleOutlined,
    ApartmentOutlined,
    BadgeOutlined,
    SignpostOutlined,
    SmartphoneOutlined
} from "@mui/icons-material";
import IngresoSelectFuncion from "../../Modulo_formularios/Componentes/IngresoSelectFuncion";
import {useContext, useEffect, useState} from "react";
import {obtenerObjLocal} from "../../Servicios/BDLocal/obtenerObjLocal";
import {contexData} from "../../App";
import IngresoCheck from "../../Modulo_formularios/Componentes/IngresoCheck";

const Formulario_Direccion = ({...props}) => {
    const cData = useContext(contexData)
    const [ciudad, setCiudad] = useState({})

    const obtenerCiudad = (nombre) => {

        let index = cData.rutas.findIndex((e) => e.ciudad === nombre)
        if (index > -1) {
            setCiudad(cData.rutas[index])
        }

    }

    useEffect(() => {

        let usu = obtenerObjLocal({key: 'usuario'})
        if (usu) {

            props.props.setValue('nombre', usu.nombre)
            props.props.setValue('ciudad', usu.ciudad)
            props.props.setValue('otraCiudad', usu.otraCiudad)
            props.props.setValue('direccion', usu.direccion)
            props.props.setValue('celular', usu.celular)
            props.props.setValue('otroCelular', usu.otroCelular)
            props.props.setValue('indicaciones', usu.indicaciones)
            props.props.setValue('cc', usu.cc)

        }

    }, []);
    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Typography>Datos de entrega</Typography>
                </Grid>

                <Grid container size={6}>
                    <IngresoTexto Icono={AccountCircleOutlined} nombre={'Nombre'} dato={'nombre'} {...props}
                                  requerido={'El Nombre es requerido'}
                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoTexto Icono={BadgeOutlined} nombre={'Num Identificacion'} dato={'cc'} {...props}
                                  requerido={'El Num Identificacion es requerido'} type={'number'} />
                </Grid>

                <Grid container size={6}>
                    <IngresoSelectFuncion Icono={ApartmentOutlined} nombre={'Ciudad'} dato={'ciudad'} {...props}
                                          opciones={cData.rutas.map((it) => it.ciudad)} setDato={obtenerCiudad}
                    />
                </Grid>

                <Grid container size={6}>
                    <Typography sx={{
                        fontSize: 12,
                        fontWeight: 400,
                        lineHeight: 1.1
                    }}>{ciudad?.descripcion}</Typography>
                </Grid>

                {ciudad?.ciudad === 'Otros' &&
                    <Grid container size={12}>
                        <IngresoTexto Icono={ApartmentOutlined} nombre={'Nombre de la ciudad'}
                                      dato={'otraCiudad'} {...props} />
                    </Grid>
                }


                <Grid container size={12}>
                    <IngresoTexto Icono={SignpostOutlined} nombre={'Direccion'} dato={'direccion'} {...props} />
                </Grid>

                <Grid container size={6}>
                    <IngresoTexto Icono={SmartphoneOutlined} nombre={'Celular'} dato={'celular'} {...props}
                                  requerido={'El numero de celular es requerido'}
                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoTexto Icono={SmartphoneOutlined} nombre={'Otro Celular'} dato={'otroCelular'} {...props} />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto lineas={4} nombre={'Indicaciones adicionales'} dato={'indicaciones'} {...props} />
                </Grid>

                <Grid container size={12} sx={{px: 1}}>
                    <Typography sx={{
                        fontSize: 12,
                        fontWeight: 400,
                        lineHeight: 1.1
                    }}>{`**El pedido sera enviado via WhatsApp a uno de nuestros operario para finalizar el proceso`}</Typography>
                </Grid>


                <Grid container size={1}>
                    <IngresoCheck {...props} dato={'guardar'}/>
                </Grid>

                <Grid container size={11} sx={{pl: 1}}>
                    <Typography sx={{fontSize: 14}}>Recordar mis datos en este dispositivo</Typography>
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Direccion